<template>
  <div class="color-range-legend">
    <div class="legend-items">
      <svg
        :width="rectWidth * items.colors.length + separate * (items.colors.length-1)"
        :height="rectHeight"
      >
        <rect
          v-for="(color, index) in items.colors"
          :style="{ fill: color }"
          :width="rectWidth"
          :height="rectHeight"
          :x="rectWidth * index + separate * index"
          class="legend-item"
        />
      </svg>
    </div>
    <div class="label label-left float-left">
      {{ items.labels.left }}
    </div>

    <div class="label label-left float-right">
      {{ items.labels.right }}
    </div>
  </div>
</template>

<script>
// Component for D3 Legend
export default {
  name: 'ColorRangeLegend',
  props: {
    items: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      rectWidth: 40,
      rectHeight: 8,
      separate: 4,
    }
  },
}
</script>

<style lang="scss">
  .color-range-legend {
    border: 1px solid #dfe2ee;
    border-radius: 4px;
    padding: 16px;
    display: inline-block;
    .legend-item {

      float: left;
      margin-left: 4px;
      &:first-child {

        margin-left: 0;
      }
    }
    .label {

      margin-top: 4px;
      font-size: 11px;
      color: #1f2638;
      font-family: 'GT Cinetype Mono', Helvetica, Roboto, Arial, sans-serif;
    }
  }

</style>
